import React from 'react'
import "./css/AboutMe.css"
import AOS from 'aos';
import Next from "./Next.js"
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
import Footer from "./Footer.js"

function AboutMe() {
    AOS.init();
  
    
    return (
        
        <div   className="aboutus_container">
            <div className="aboutus">
                <div className="aboutus__sidebar">
                    <h2>About</h2>
                </div>
                <div  data-aos="fade-right"  
                    data-aos-duration="2000" className="aboutus__picture">
                
                        <div className="aboutus__pictureshow">
                        <figure className="figure"> <img src="./me.jpeg" alt=""></img></figure>
                            <div className="abaout_usborder"></div>
                        </div>
                    
                </div>
                <div  data-aos="fade-left" 
                        data-aos-duration="2000"   className="aboutus__info">
                    <div className="aboutus_infocontainer">
                        <div className="aboutus__infotext" >
                            <p>My name is <b>Bucur Alexandru Florin</b> and I am from Romania . I am working as a front-end web developer using technologies such as HTML,CSS,React and @material-ui.I am a self learned programmer and i love to master new things and get better at them. I am passioned about coding since i was in highschool and i will probably NEVER end.</p>
                        </div>
                        
                    </div>
                
                    
                </div>
            </div>
            
            <div data-aos="fade-in"  
                    data-aos-duration="2000" className="aboutus_study">
                <h1>Studies</h1>
            </div>
            <section  className="studies">
                <div className="left">
                    <article data-aos="fade-right"  
                    data-aos-duration="3000" className="article-about">
                       <time>1st June 1998</time>
                       <div className="content-center"> <h2>I was born</h2></div>
                      
                    </article>
                     <article  data-aos="fade-right"  
                    data-aos-duration="3000" className="article-about">
                     <time>1 Sempember 2005 - 1 July 2013</time>
                        <div className="content-center"> 
                            <h3>Economic College of Buzau</h3>
                            <p><b>Licence in Economics and Tourism Industry </b></p>
                        </div>
                    </article>
                    <article data-aos="fade-right"  
                    data-aos-duration="3000"  className="article-about">
                    <time>Present</time>
                        <div className="content-center"> 
                            <h3>Front Web Dev Intern</h3>
                            <p><b>I am working as an Intern at Sicilia Mia </b></p>
                        </div>
                    </article>
                </div>
                <div className="right">
                <article data-aos="fade-left"  
                    data-aos-duration="3000"  className="article-about">
                        <time>1 Sempember 2005 - 1 July 2013</time>
                        <div className="content-center"> 
                            <h3> Elementary School of Ghimbav </h3>
                            <p><b>Str. Pieții nr.70 Ghimbav, jud.Brașov (Romania)</b></p>
                        </div>
                    </article>
                    <article data-aos="fade-left"  
                    data-aos-duration="3000"  className="article-about">
                    <time>1 Octomber 2017 - 1 July 2020</time>
                        <div className="content-center"> 
                            <h3> Transylvania University of Brasov </h3>
                            <p><b>Economic ,Statistics and Informatic Degree</b></p>
                        </div>
                    </article>
                </div>
                
            </section>
            <div data-aos="fade-in"  
                    data-aos-duration="3000" className="aboutus_study">
                <h1>Hobbies</h1>
            </div>
            <section className="hobbies" >
                <div className="code" data-aos="fade-left"  
                    data-aos-duration="3000">
                    <div className="hobby_image">
                        <img src="./code.png" alt="code"/>
                    </div>
                    <div className="hobby_text" >
                        <h2>Coding</h2>
                        <p>I LOVE TO CODE . Since i was in highschool i've started building interest in coding. Now i am trying to learn as much as I can , how I can. I've started with HTML and CSS and grinded up to React and Node JS</p>
                    </div>
                </div>
                <div className="footbal" data-aos="fade-right"  
                    data-aos-duration="3000">
                    <div className="hobby_text">
                        <h2>Football</h2>
                        <p>I've played football since i was 5 years old . I used to watch every Liverpool game since Steven Gerard was my favourite . Now I don't enjoy it as much but i still play from time to time.</p>
                    </div>  
                    <div className="hobby_image">
                        <img src="./fotball.jpg" alt="code"/>
                    </div>
                   
                </div>
                <div className="bascket" data-aos="fade-left"  
                    data-aos-duration="3000">
                    
                <div className="hobby_image">
                        <img src="./bascket.jpg" alt="code"/>
                    </div>
                    <div className="hobby_text">
                        <h2>basketball</h2>
                        <p>I honestly started playing basket 2 years ago but I really enjoy it. I've grown pretty good at it for a street standard . I love to play with the boys and listen to old school hip-hop music.</p>
                    </div>
                </div>
                <div className="gaming" data-aos="fade-right"  
                    data-aos-duration="3000">
                    <div className="hobby_text">
                        <h2>Gaming</h2>
                        <p>I am a Gamer and I always been . I've started with Mario on an old pc . I've grown up with games such us GTA , Need  For Speed and Assasin Creed. Now I am playng APEX ,RDR2 and many others . Join Me !!</p>
                    </div>   
                <div className="hobby_image">
                        <img src="./gaming.jpg" alt="code"/>
                </div>
                    
                </div>
            </section>
            <Next name="Projects" islast={true} isAbout={false} href="/projects"/>
            <Footer/>
        </div>
    )
}

export default AboutMe
